import React from 'react';
import PropTypes from 'prop-types';
import {primaryColor} from "../../assets/jss/material-dashboard-react";

import {
    withStyles,
    CircularProgress
} from "@material-ui/core";


const styles={
    progress:{
        color:primaryColor
    },
    rightside:{
        marginLeft:"auto"
    }

}

const LoadingSpinner = ({size,thickness})=>{

     let Size =size?size:50;
     let Thickness = thickness?thickness:5;

    return(
        <div style={styles.rightside}>
            <CircularProgress style={styles.progress} size={Size} thickness={Thickness}/>

        </div>
    )
}

export default withStyles(styles)(LoadingSpinner)


// WEBPACK FOOTER //
// ./src/components/LoadingSpinner/LoadingSpinner.jsx